import React, { Fragment, useState, useEffect } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import CommunityInnerpageBanner from "./community-inner-banner";

import CommunityInnerpageDescription from "./community-inner-descriptions";
import CommunityInnerpageFeature from "./community-inner-feature";
import CommunityInnerpageLocation from "./community-inner-location";
import CollectionInnerProperties from "./community-inner-properties";

import { useParams } from "react-router-dom";
import * as apiUrl from "../../apiUrl";

import logo from "../../assets/marquis-logo.svg";

function CommunityInnerPage() {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [sections, setSections] = useState({});

  useEffect(() => {
    const fetchData = async (endpoint, sectionKey) => {
      try {
        const response = await fetch(
          `${apiUrl.apiUrl}/api/communities-inner/${endpoint}/${slug}`
        );
        if (!response.ok) throw new Error(`${sectionKey} not found`);
        const data = await response.json();
        setSections((prev) => ({ ...prev, [sectionKey]: data }));
      } catch (error) {
        console.error(`Error fetching ${sectionKey}:`, error);
      }
    };

    // Reset loading and sections when the slug changes
    setLoading(true);
    setSections({});

    const fetchAllSections = async () => {
      await Promise.all([
        fetchData("page", "page"),
        fetchData("second-section", "second_section"),
        fetchData("features", "features_section"),
        fetchData("location", "location_section"),
        fetchData("properties", "properties_section"),
      ]);
      setLoading(false); // Once all data is fetched, set loading to false
    };

    fetchAllSections();
  }, [slug]); // Dependency on `slug` ensures this effect runs every time the URL changes

  if (loading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

  if (!sections.page) {
    return <p>Page not found.</p>;
  }

  const {
    page,
    second_section,
    features_section,
    location_section,
    properties_section,
  } = sections;

  return (
    <Fragment>
      <Header />
      <CommunityInnerpageBanner
        bannerImage={page.banner_image}
        bannerTitle={page.banner_title}
      />
      {second_section && (
        <CommunityInnerpageDescription
          title={second_section.section_title}
          descriptions={second_section.section_description}
          sectionImage={second_section.section_image}
        />
      )}
      {features_section && (
        <CommunityInnerpageFeature
          sectionTitle={features_section.section_title}
          features={features_section}
        />
      )}
      {location_section && (
        <CommunityInnerpageLocation
          title={location_section.section_title}
          description={location_section.section_description}
          cards={location_section.location_cards}
        />
      )}
      {properties_section && (
        <CollectionInnerProperties
          title={properties_section.section_title}
          cards={properties_section.card_content}
        />
      )}
      <Footer />
    </Fragment>
  );
}
export default CommunityInnerPage;
